import styled from 'styled-components';
import { Body } from '@grnhse/seedling/lib/birch/typography';

const InlineBody = styled(Body).attrs({
  as: 'span',
})``;

export default InlineBody;
